/**
 * Helpers for reading numeric `<input>` values without letting NaN escape into
 * application state.
 *
 * `parseFloat('')` and `parseInt('')` both return NaN. Assigning that straight
 * into state persists NaN to Firestore, which stores non-finite doubles
 * natively — so nothing fails at write time. It surfaces much later: strict
 * JSON decoders reject it, and the Go pattern-detection service could not read
 * the affected documents at all.
 *
 * It also stays invisible in the UI, because read paths typically guard with a
 * falsy check (`maxRisk ? ... : '∞'`) and NaN is falsy — so the field renders
 * exactly as intended while the stored value is corrupt.
 */

/** Parse a decimal input, returning `fallback` when empty or unparseable. */
export const parseFloatOr = (raw: string, fallback: number): number => {
  const parsed = parseFloat(raw)
  return Number.isNaN(parsed) ? fallback : parsed
}

/** Parse an integer input, returning `fallback` when empty or unparseable. */
export const parseIntOr = (raw: string, fallback: number): number => {
  const parsed = parseInt(raw, 10)
  return Number.isNaN(parsed) ? fallback : parsed
}
